<template>
  <section class="py-24 w-full max-w-2xl mx-auto">
    <div class="flex flex-col gap-y-4">
      <h1 class="text-center text-xl font-bold leading-tight tracking-tighter md:text-3xl lg:leading-[1.1]">
        FAQ — Frequenly Asked Questions 🐱
      </h1>

      <Accordion type="single" class="w-full" collapsible :default-value="defaultValue">
        <AccordionItem v-for="item in accordionItems" :key="item.value" :value="item.value">
          <AccordionTrigger class="text-left">{{ item.title }}</AccordionTrigger>
          <AccordionContent>
            {{ item.content }}
          </AccordionContent>
        </AccordionItem>
      </Accordion>
    </div>
  </section>
</template>

<script lang="ts" setup>
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';

const defaultValue = 'item-1';

const accordionItems = [
  {
    value: 'item-1',
    title: 'What is Yt2Tweets?',
    content:
      'Yt2Tweets is a web platform powered by AI that converts YouTube videos into concise Twitter / X threads. By pasting a YouTube link, users can generate engaging Twitter threads based on the video’s content, with customizable options to meet their needs.',
  },
  {
    value: 'item-2',
    title: 'How does Yt2Tweets work?',
    content:
      'Simply paste the link to any YouTube video, and Yt2Tweets will analyze the video content. The AI then creates a Twitter thread that summarizes key points, quotes, or sections from the video. Users can configure the output style to fit their goals.',
  },
  {
    value: 'item-3',
    title: 'What types of posts can I create using Yt2Tweets?',
    content:
      'Yt2Tweets is flexible and designed to help users create a variety of posts, including: "Campaign posts", "Awareness posts", "Educational posts", "Viral posts". You can customize the style and length of your threads to suit your needs.',
  },
  {
    value: 'item-4',
    title: 'Can I customize the output of the Twitter thread?',
    content:
      'Yes, users have the ability to configure various aspects of the thread output, such as the tone, length, and focus areas, allowing you to tailor the thread to align with your goals.',
  },
  {
    value: 'item-5',
    title: 'Is Yt2Tweets free to use?',
    content: `Yt2Tweets will offer both free and premium versions. The free version includes 3 credits per day. You can purchase additional credits with $5.99 for 3 credits or $15.99 for 10 credits.`,
  },
  {
    value: 'item-6',
    title: 'What platforms can I share the output to?',
    content: `Currently, Yt2Tweets is optimized for Twitter / X, allowing users to easily share their generated threads directly on these platforms.`,
  },
  {
    value: 'item-7',
    title: 'What kinds of videos work best with Yt2Tweets?',
    content: `Yt2Tweets is designed to work with a wide variety of YouTube videos, from educational content to vlogs, interviews, tutorials, and more. The AI is trained to summarize long-form videos while preserving the most important points.`,
  },
  {
    value: 'item-8',
    title: 'How can Yt2Tweets help grow my social media presence?',
    content: `By turning long YouTube videos into bite-sized, shareable content, Yt2Tweets helps you engage your audience more effectively on Twitter / X. It’s especially useful for sharing impactful ideas quickly, raising awareness, or going viral with trending topics.`,
  },
  {
    value: 'item-9',
    title: 'Is Yt2Tweets available for mobile users?',
    content: `Yes! Yt2Tweets is a web-based platform, which means it is accessible from both desktop and mobile browsers.`,
  },
  {
    value: 'item-10',
    title: 'How do I get started with Yt2Tweets?',
    content: `To get started, visit the Yt2Tweets website, paste a YouTube link, configure your preferences, and let the AI generate a Twitter thread for you. You can then preview, edit, and post your thread directly to Twitter / X`,
  },
];
</script>

<style></style>
